import { UserManager } from 'oidc-client';

import config from 'core/config';

const manager = new UserManager({
  authority: 'x',
  client_id: config.auth.clientId,
  redirect_uri: `${window.location.origin}/authentication/callback`,
  response_type: 'id_token token',
  scope: 'openid email',
  loadUserInfo: false,
  metadata: {
    issuer: config.auth.authorityUrl,
    authorization_endpoint: config.auth.authorizationEndpoint,
    jwks_uri: config.auth.jwksUri
  }
});

export default manager;
